import React from 'react';

const Section = ({ label, children }) => (
  <div style={{ marginBottom: 14 }}>
    <div style={{ fontSize: 11, fontWeight: 700, color: '#374151', marginBottom: 4 }}>{label}</div>
    {children}
  </div>
);

const input = { width: '100%', padding: '6px 8px', fontSize: 13, border: '1px solid #d1d5db', borderRadius: 4 };

const FIT_MODES = [
  { value: 'fixed', label: 'Fixed Size', desc: 'Font stays at set size. Text clips if too long.' },
  { value: 'shrink_to_fit', label: 'Shrink to Fit', desc: 'Reduces font only when needed so text fits on one line.' },
  { value: 'best_fit', label: 'Best Fit', desc: 'Auto-sizes font to fill the box as large as possible on one line.' },
  { value: 'word_wrap', label: 'Word Wrap', desc: 'Wraps text at word boundaries. Font stays fixed.' },
];

function Row({ label, children }) {
  return (
    <div style={{ marginBottom: 8 }}>
      <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 2 }}>{label}</div>
      {children}
    </div>
  );
}

function TextProps({ element, onChange, onDelete }) {
  const patch = (p) => onChange({ ...element, ...p });
  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
        <div style={{ fontSize: 14, fontWeight: 600 }}>✏ Text</div>
        <button onClick={onDelete} style={{ background: '#ef4444', color: '#fff', border: 0, padding: '4px 10px', borderRadius: 4, cursor: 'pointer' }}>Delete</button>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
        <Row label="X"><input type="number" style={input} value={element.x} onChange={(e) => patch({ x: Number(e.target.value) })} /></Row>
        <Row label="Y"><input type="number" style={input} value={element.y} onChange={(e) => patch({ y: Number(e.target.value) })} /></Row>
        <Row label="Width"><input type="number" style={input} value={element.width} onChange={(e) => patch({ width: Number(e.target.value) })} /></Row>
        <Row label="Height"><input type="number" style={input} value={element.height} onChange={(e) => patch({ height: Number(e.target.value) })} /></Row>
      </div>
      <Row label="Text Content">
        <textarea rows={3} style={{ ...input, resize: 'vertical', fontFamily: 'inherit' }}
          value={element.text_content || ''} onChange={(e) => patch({ text_content: e.target.value })} />
      </Row>
      <Row label="Insert Variable">
        <select
          style={input}
          value=""
          onChange={(e) => {
            if (!e.target.value) return;
            patch({ text_content: (element.text_content || '') + e.target.value });
            e.target.value = '';
          }}
        >
          <option value="">— Insert —</option>
          <option value="{student_name}">{'{student_name}'}</option>
          <option value="{school_name}">{'{school_name}'}</option>
          <option value="{season}">{'{season}'}</option>
        </select>
      </Row>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
        <Row label="Font Size"><input type="number" style={input} value={element.font_size || 40} onChange={(e) => patch({ font_size: Number(e.target.value) })} /></Row>
        <Row label="Color"><input type="color" style={{ ...input, padding: 2, height: 32 }} value={element.color || '#ffffff'} onChange={(e) => patch({ color: e.target.value })} /></Row>
      </div>
      <Section label="TEXT FIT MODE">
        {FIT_MODES.map((m) => {
          const active = (element.fit_mode || 'shrink_to_fit') === m.value;
          return (
            <div
              key={m.value}
              onClick={() => patch({ fit_mode: m.value })}
              style={{
                padding: 8, border: `1px solid ${active ? '#7c3aed' : '#e5e7eb'}`, borderRadius: 4, cursor: 'pointer',
                marginBottom: 4, background: active ? '#f5f3ff' : '#fff',
              }}
            >
              <div style={{ fontSize: 12, fontWeight: 600 }}>{m.label}</div>
              <div style={{ fontSize: 11, color: '#6b7280' }}>{m.desc}</div>
            </div>
          );
        })}
      </Section>
    </>
  );
}

function PhotoProps({ element, onChange, onDelete }) {
  const patch = (p) => onChange({ ...element, ...p });
  const shadow = element.drop_shadow || {};
  const patchShadow = (p) => patch({ drop_shadow: { ...shadow, ...p } });
  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
        <div style={{ fontSize: 14, fontWeight: 600 }}>👤 Photo Placeholder</div>
        <button onClick={onDelete} style={{ background: '#ef4444', color: '#fff', border: 0, padding: '4px 10px', borderRadius: 4, cursor: 'pointer' }}>Delete</button>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
        <Row label="X"><input type="number" style={input} value={element.x} onChange={(e) => patch({ x: Number(e.target.value) })} /></Row>
        <Row label="Y"><input type="number" style={input} value={element.y} onChange={(e) => patch({ y: Number(e.target.value) })} /></Row>
        <Row label="Width"><input type="number" style={input} value={element.width} onChange={(e) => patch({ width: Number(e.target.value) })} /></Row>
        <Row label="Height"><input type="number" style={input} value={element.height} onChange={(e) => patch({ height: Number(e.target.value) })} /></Row>
      </div>
      <Row label="Pose">
        <select style={input} value={element.pose_number || 1} onChange={(e) => patch({ pose_number: Number(e.target.value) })}>
          {Array.from({ length: 20 }, (_, i) => i + 1).map((n) => <option key={n} value={n}>Pose {n}</option>)}
        </select>
      </Row>
      <Row label="Orientation">
        <div style={{ display: 'flex', gap: 6 }}>
          {['4x5', '5x4'].map((o) => (
            <button
              key={o}
              onClick={() => patch({ orientation: o })}
              style={{
                flex: 1, padding: '6px 8px', fontSize: 12,
                border: `1px solid ${element.orientation === o ? '#7c3aed' : '#d1d5db'}`,
                background: element.orientation === o ? '#f5f3ff' : '#fff', borderRadius: 4, cursor: 'pointer',
              }}
            >{o.replace('x', '×')}</button>
          ))}
        </div>
      </Row>
      <Row label="Label"><input type="text" style={input} value={element.label || ''} onChange={(e) => patch({ label: e.target.value })} /></Row>
      <Row label="Shape">
        <select style={input} value={element.shape || 'rectangle'} onChange={(e) => patch({ shape: e.target.value })}>
          <option value="rectangle">Rectangle</option>
          <option value="circle">Circle</option>
          <option value="rounded">Rounded</option>
        </select>
      </Row>
      <label style={{ display: 'flex', alignItems: 'center', fontSize: 13, gap: 6, marginTop: 8, cursor: 'pointer' }}>
        <input type="checkbox" checked={!!shadow.enabled} onChange={(e) => patchShadow({ enabled: e.target.checked })} />
        Drop Shadow
      </label>
      {shadow.enabled && (
        <div style={{ border: '1px solid #e5e7eb', padding: 8, borderRadius: 4, marginTop: 6 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
            <Row label="Color"><input type="color" style={{ ...input, padding: 2, height: 32 }} value={shadow.color || '#000000'} onChange={(e) => patchShadow({ color: e.target.value })} /></Row>
            <Row label="Opacity %"><input type="number" min={0} max={100} style={input} value={shadow.opacity ?? 50} onChange={(e) => patchShadow({ opacity: Number(e.target.value) })} /></Row>
          </div>
          <Row label={`Blur (px): ${shadow.blur ?? 10}`}>
            <input type="range" min={0} max={60} value={shadow.blur ?? 10} onChange={(e) => patchShadow({ blur: Number(e.target.value) })} style={{ width: '100%' }} />
          </Row>
          <Row label={`X Offset: ${shadow.x_offset ?? 0}`}>
            <input type="range" min={-40} max={40} value={shadow.x_offset ?? 0} onChange={(e) => patchShadow({ x_offset: Number(e.target.value) })} style={{ width: '100%' }} />
          </Row>
          <Row label={`Y Offset: ${shadow.y_offset ?? 0}`}>
            <input type="range" min={-40} max={40} value={shadow.y_offset ?? 0} onChange={(e) => patchShadow({ y_offset: Number(e.target.value) })} style={{ width: '100%' }} />
          </Row>
        </div>
      )}
    </>
  );
}

export default function PropertiesPanel({ element, onChange, onDelete }) {
  return (
    <div style={{ width: 280, borderLeft: '1px solid #e5e7eb', padding: 16, overflowY: 'auto', background: '#fff' }}>
      <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 0.8, color: '#6b7280', marginBottom: 10 }}>PROPERTIES</div>
      {!element && <div style={{ fontSize: 13, color: '#9ca3af' }}>Click an element on the canvas or in the list to edit</div>}
      {element?.type === 'text' && <TextProps element={element} onChange={onChange} onDelete={onDelete} />}
      {element?.type === 'photo' && <PhotoProps element={element} onChange={onChange} onDelete={onDelete} />}
    </div>
  );
}
